import { render, staticRenderFns } from "./ProductBuy.vue?vue&type=template&id=06e8153d&scoped=true"
import script from "./ProductBuy.vue?vue&type=script&lang=js"
export * from "./ProductBuy.vue?vue&type=script&lang=js"
import style0 from "./ProductBuy.vue?vue&type=style&index=0&id=06e8153d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8153d",
  null
  
)

export default component.exports